import React, { FunctionComponent } from 'react';
import { Result, Button } from 'antd';
import { goTo } from '@helpers/navigation';
import routes from '@config/routes';
import useTranslate from '@hooks/useTranslate';
import history from '@helpers/history';
import componentContent from './ErrorPage.json';
import css from './ErrorPage.module.less';

type PropsErrorPage = {
  responseStatus: 404 | '404';
  title?: string;
  description?: string;
};

const Extra = () => {
  const content = useTranslate(componentContent, false);

  const handleClickGoBack = () => {
    history.goBack();
  };

  const handleClickGoHome = () => {
    goTo(routes.userList.name);
  };

  return (
    <div className={css.containerButtons}>
      <Button
        type='primary'
        onClick={handleClickGoBack}
      >
        {content.buttonGoBack}
      </Button>
      <Button
        type='primary'
        onClick={handleClickGoHome}
      >
        {content.buttonGoHome}
      </Button>
    </div>
  );
};

const ErrorPage: FunctionComponent<PropsErrorPage> = (props) => {
  const { responseStatus, title, description } = props;
  const content = useTranslate(componentContent, false);

  return (
    <Result
      status={responseStatus}
      title={title || responseStatus}
      subTitle={description || content.description}
      extra={<Extra />}
    />
  );
};

export default ErrorPage;
